import React from 'react';

interface FeatureCard {
  title: string;
  description: string;
  icon?: string;
}

const Tools: React.FC = () => {
  const features: FeatureCard[] = [
    {
      title: "Expert Analysis",
      description: "Rob’s real-time insights , dissecting market trends and technical data for junior mining stocks."
    },
    {
      title: "Educational Mastery",
      description: "Courses teach due diligence (e.g., assessing geology, management, jurisdictions), speculation strategies (e.g., timing catalysts), and risk management, aligning with the sophistication of master speculators."
    },
    {
      title: "Actionable Tools",
      description: "Connect with investors to share mining investment strategies on Mighty Networks, with live Q&As and proprietary tools like due diligence checklists."
    },
    {
      title: "Collaborative Power",
      description: "Deep-dive reports and resources in our Resources Hub, help you navigate volatility and avoid pitfalls like overhyped stocks. With limited founding memberships, The Wealthy Miner fosters disciplined mining speculation through Rob’s proven framework. "
    },
  ];

  return (
    <section className="mx-auto px-4 md:px-10 lg:px-32 w-full bg-[#F6F6F6] pt-20 pb-20">
      <div className="">
        {/* Header Section */}
        <div className="text-center mb-16">
          <h2 className="text-[30px] md:text-[40px] lg:text-[32px] font-[700] leading-[40px] text-[#000] mb-7">
          Actionable Tools
          </h2>
        </div>

        {/* Features Grid - All Screen Sizes */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-6 sm:gap-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="bg-white rounded-[10px] p-6 sm:p-8"
            >
              <div className="mb-3">
                <div className="w-16 h-16 flex items-center justify-left mb-4">
                  {index === 0 ? (
                    <img 
                      src="/images/expert.webp" 
                      alt="Stock icon" 
                      className="w-10 h-10 object-contain"
                    />
                  ) : index === 1 ? (
                    <img 
                      src="/images/book.webp" 
                      alt="Time icon" 
                      className="w-10 h-10 object-contain"
                    />
                  ) : index === 2 ? (
                    <img 
                      src="/images/diamond.webp" 
                      alt="Deep analysis icon" 
                      className="w-10 h-10 object-contain"
                    />
                  ) : index === 3 ? (
                    <img 
                      src="/images/collaboration.webp" 
                      alt="Deep analysis icon" 
                      className="w-10 h-10 object-contain"
                    />
                  ) : (
                    <span className="text-white text-2xl font-bold">
                      {index + 1}
                    </span>
                  )}
                </div>
                <h3 className="lg:text-[26px] text-[20px] font-[600] text-[#000]">
                  {feature.title}
                </h3>
              </div>
              <p className="lg:text-[18px] text-[16px] text-[#000] leading-[1.6]">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Tools;
